/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import crel from "crel";
import { disableMenu, enableMenu } from "../formatting-toolbar/state";
import { tocLinkClick } from "./handlers";
export class TocView {
    constructor(node, view, getPos) {
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.type = node.type;
        this.dom = crel("div", { class: "table-of-contents" }, (this.input = crel("div", { class: "table-of-contents__head", contenteditable: false }, crel("div", { class: "table-of-contents__head-arrow" }), crel("div", { class: "table-of-contents__head-title" }, `Table of Contents`))), (this.contentDOM = crel("div", { class: "table-of-contents__content" })));
        this.input.addEventListener("click", () => {
            view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
                expanded: !this.node.attrs.expanded,
            }));
        });
        this.contentDOM.addEventListener("click", (e) => {
            tocLinkClick(e);
        });
        this.update(node);
    }
    update(node) {
        this.node = node;
        if (node.type !== this.type) {
            return false;
        }
        if (node.attrs.expanded) {
            this.dom.classList.add("table-of-contents--expanded");
        }
        else {
            this.dom.classList.remove("table-of-contents--expanded");
        }
        return true;
    }
    selectNode() {
        this.view.dispatch(disableMenu(this.view.state.tr));
    }
    deselectNode() {
        this.view.dispatch(enableMenu(this.view.state.tr));
    }
}
